import { useNavigate } from "react-router-dom";
import SignUpCard from "../../common/SignUpCard";
import HomeLayout from "../../layouts/home.layout";

import { signUpCardConfigs } from "../../utils/constant/landingPage.constant";

const LandingPage = () => {
  const navigate = useNavigate();
  return (
    <HomeLayout>
      <div className="flex items-center justify-center flex-col py-12 gap-4 px-3 md:px-0">
        <h1 className="text-xl md:text-3xl font-semibold leading-normal mt-5 md:mt-2">Get started with Lystproof</h1>
        <span className="text-sm md:text-base">Choose your account type and begin your journey.</span>
      </div>
      <div className="flex flex-wrap justify-center gap-12 gap-y-16 py-10 pb-14 md:pb-12 max-w-5xl mx-auto px-3 md:px-0">
        {signUpCardConfigs.map((card) => (
          <SignUpCard
            key={card?.id}
            {...card}
            onCLickHandler={() => navigate(`/sign-up/${card.userTypekey}`)}
            bottomContent={{ text: "Already have an account?", link: { text: "Login", value: `/login/${card.userTypekey}` } }}
          />
        ))}
      </div>
    </HomeLayout>
  );
};

export default LandingPage;
